var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "basket-user d-lg-flex align-content-lg-center",
      attrs: { id: "login-change" },
    },
    [
      _vm.isLoggedIn
        ? _c("div", { staticClass: "dropdown" }, [
            _c(
              "a",
              {
                staticClass: "basket-user__icon",
                attrs: {
                  href: "#",
                  id: "accountMenuList",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  "data-boundary": "window",
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "22",
                      height: "22",
                    },
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#user",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "hidden-xs-down" }, [
                  _vm._v("Logout"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "account-menu dropdown-menu small" }, [
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  attrs: { href: _vm.$ceres.urls.myAccount },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  directives: [{ name: "logout", rawName: "v-logout" }],
                  staticClass: "dropdown-item",
                  attrs: { href: "#" },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoggedIn
        ? _c("div", { staticClass: "dropdown" }, [
            _c(
              "a",
              {
                staticClass: "basket-user__icon",
                attrs: {
                  href: "#",
                  id: "accountMenuList",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  "data-boundary": "window",
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "22",
                      height: "22",
                    },
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#user",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "d-none d-xl-block" }, [
                  _vm._v("Login"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "account-menu dropdown-menu small" }, [
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  attrs: {
                    "data-testing": "login-select",
                    href: _vm.isLogin ? "javascript:void(0)" : "#login",
                    "data-toggle": _vm.isLogin ? false : "modal",
                  },
                  on: {
                    click: function ($event) {
                      _vm.createLoginModal()
                      _vm.unmarkInputFields()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "hidden-xs-down" }, [
                    _vm._v(_vm._s(_vm.$translate("Ceres::Template.login"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.showRegistration
                ? _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      attrs: {
                        "data-testing": "register-select",
                        href: _vm.isRegister
                          ? "javascript:void(0)"
                          : "#registration",
                        "data-toggle": _vm.isRegister ? false : "modal",
                      },
                      on: {
                        click: function ($event) {
                          _vm.createRegisterModal()
                          _vm.unmarkInputFields()
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "hidden-xs-down" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.loginRegister")
                          )
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }